import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';

export enum ENotificationsRoute {
  notifications = 'notifications',
  list = 'list',
}

TaRoutes.addRoute({
  key: ENotificationsRoute.notifications,
  url: 'notifications',
  children: [
    {
      key: ENotificationsRoute.list,
      url: 'list',
    },
  ],
});

export const notificationsRoutes: Routes = [
  {
    path: TaRoutes.getUrl([ENotificationsRoute.notifications, ENotificationsRoute.list]),
    title: 'app.pages.notifications.title',
    loadComponent: () =>
      import('./pages/notifications-list/notifications-list').then((c) => c.NotificationsListPage),
  },
];
